import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=2d04864d&"
import script from "./CreateTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d04864d')) {
      api.createRecord('2d04864d', component.options)
    } else {
      api.reload('2d04864d', component.options)
    }
    module.hot.accept("./CreateTemplate.vue?vue&type=template&id=2d04864d&", function () {
      api.rerender('2d04864d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whatsapp/template/CreateTemplate.vue"
export default component.exports